import type { RegionData } from "@/interface/common/location_inteface";
import region from "@/data/location.json";

export class LocationServices {
  async fetchLocations(): Promise<RegionData[]> {
    try {
      return region;
    } catch (e) {
      throw Error;
    }
  }
}
